/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CheckAIcon16Light } from './CheckAIcon16Light';
import { CheckAIcon16Regular } from './CheckAIcon16Regular';
import { CheckAIcon16Solid } from './CheckAIcon16Solid';
import { CheckAIcon20Light } from './CheckAIcon20Light';
import { CheckAIcon20Regular } from './CheckAIcon20Regular';
import { CheckAIcon20Solid } from './CheckAIcon20Solid';
import { CheckAIcon24Regular } from './CheckAIcon24Regular';
import { CheckAIcon24Solid } from './CheckAIcon24Solid';
import { CheckAIcon32Regular } from './CheckAIcon32Regular';
import { CheckAIcon64Regular } from './CheckAIcon64Regular';
var sizes = {
    16: {
        light: CheckAIcon16Light,
        regular: CheckAIcon16Regular,
        solid: CheckAIcon16Solid,
    },
    20: {
        light: CheckAIcon20Light,
        regular: CheckAIcon20Regular,
        solid: CheckAIcon20Solid,
    },
    24: {
        regular: CheckAIcon24Regular,
        solid: CheckAIcon24Solid,
    },
    32: {
        regular: CheckAIcon32Regular,
    },
    64: {
        regular: CheckAIcon64Regular,
    },
};
export var CheckAIcon = forwardRef('CheckAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
